// Тексты мастера «Импорт контактов»: шаги, правила под кнопкой выбора файла и пример CSV для скачивания.
import { t } from "@/lib/i18n";

// шаги мастера
export const importSteps = [
  { id: 1, label: t("Загрузка CSV-файла") },
  { id: 2, label: t("Сопоставление") },
  { id: 3, label: t("Проверка") },
];

// правила под кнопкой выбора файла (как проверяет сервер)
export const importInstructions = [
  t("Проще всего заполнить шаблон («Скачать шаблон») — колонки сопоставятся сами. Подойдёт и выгрузка из Zoho CRM или другой CRM."),
  t("Существующие контакты ищутся по колонке ID контакта, затем по email, затем по телефону — найденные обновятся, остальные добавятся."),
  t("Размер файла не должен превышать 20 МБ."),
  t("В файле должно быть меньше 200 000 строк."),
  t("У всех колонок должны быть заголовки, иначе их не удастся сопоставить."),
  t("Кодировка UTF-8 или Windows-1251, разделитель — запятая, точка с запятой или табуляция: определяются сами."),
];

